import { useContext, useEffect, useState } from 'react';

import { NotificationContext } from 'context/NotificationContext';

import * as S from './styles';

const DEFAULT_DURATION = 5000;

const NotificationBar: React.FC = () => {
  const { notification, setNotification } = useContext(NotificationContext);

  const [isOpen, setIsOpen] = useState(false);

  const handleOnClose = () => {
    setIsOpen(false);
    setNotification(null);
  };

  useEffect(() => {
    setIsOpen(!!notification?.message);
  }, [notification]);

  return (
    <S.Container>
      <S.NotificationBar
        open={isOpen}
        hideCloseButton
        onClose={handleOnClose}
        message={notification?.message || ''}
        variant={notification?.type || 'info'}
        duration={notification?.duration || DEFAULT_DURATION}
      />
    </S.Container>
  );
};

export default NotificationBar;
